export default {
    computed: {
        headers() {
            return [
                {
                    value: 'identifier',
                    text: this.$t('labels.identifier'),
                },
                {
                    value: 'name',
                    text: this.$t('labels.name'),
                    type: 'string',
                },
                {
                    value: 'cutoffTime',
                    text: this.$t('labels.cc_cutoff.time'),
                },
                {
                    value: 'deliveryTime',
                    text: this.$t('labels.delivery_at'),
                },
                {
                    value: 'budgetLimit',
                    text: this.$t('labels.budget'),
                },
                {
                    value: 'isRecurring',
                    text: this.$t('labels.is-recurring'),
                    type: 'string',
                },
                {
                    value: 'relatedRestaurants',
                    text: this.$t('labels.canteen_email_sent_to_restaurant'),
                    type: 'object',
                    align: 'center',
                },
                {
                    value: 'preCreateDeliveryEnabled',
                    text: this.$t('labels.canteen_pre_create_delivery_enabled'),
                    align: 'center',
                    type: 'boolean',
                },
            ]
        },
    },
}
